module.exports = __webpack_public_path__ + "img/pensee.29ebdf98.jpg";